// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DotChartOutlinedSvg from "@ant-design/icons-svg/es/asn/DotChartOutlined";
import AntdIcon from '../components/AntdIcon';

var DotChartOutlined = function DotChartOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DotChartOutlinedSvg
  }));
};

DotChartOutlined.displayName = 'DotChartOutlined';
export default React.forwardRef(DotChartOutlined);